module.exports = __webpack_public_path__ + "img/round-big.e9ca6e14.svg";